// extracted by mini-css-extract-plugin
export default {"mainContainer":"Reservar_mainContainer__vvLFs","header":"Reservar_header__D-LlA"};